import { render, staticRenderFns } from "./servants.vue?vue&type=template&id=cee1edc4"
import script from "./servants.vue?vue&type=script&lang=js"
export * from "./servants.vue?vue&type=script&lang=js"
import style0 from "./servants.vue?vue&type=style&index=0&id=cee1edc4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports